"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseFieldFactory = void 0;
const errors_1 = require("../errors");
function baseFieldFactory({ name, checkType, defaultValue, choices, isRequired = false, description = '', }) {
    if (!name) {
        throw new errors_1.FieldError('Field must have a name');
    }
    if (!checkType) {
        throw new errors_1.FieldError('Field must be provided with type checker.');
    }
    function getDefault() {
        if (typeof defaultValue === 'function') {
            return defaultValue();
        }
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : undefined;
    }
    /**
     * Checks that the value of the field is valid.
     */
    function validate(value) {
        checkType === null || checkType === void 0 ? void 0 : checkType(value);
        if (choices && value && !choices.includes(value)) {
            throw new errors_1.ValidationError(`Invalid choice for field "${name}": ${value}`);
        }
    }
    /**
     * Deserializes the value from StorageType to the FieldType
     * @param value Value of the field.
     */
    function fromDb(value) {
        if (value === undefined || value === null) {
            return getDefault();
        }
        // The base field assumes the types are the same. Each indiviual field
        // type should override this function as needed.
        const instanceValue = value;
        return instanceValue;
    }
    /**
     * Serializes the FieldType to the StorageType
     * @param value Current field value
     */
    function toDb(value) {
        if (value === undefined) {
            return undefined;
        }
        // The base field assumes the types are the same.
        const dbValue = value;
        return dbValue;
    }
    /**
     * Deserializes the ApiType to the FieldType
     * @param value The serialized api value
     */
    function fromApi(value) {
        if (value === undefined || value === null) {
            return getDefault();
        }
        // The base field assumes the types are the same.
        const instanceValue = value;
        return instanceValue;
    }
    /**
     * Serializes the FieldType to the ApiType
     * @param value The current field value
     */
    function toApi(value) {
        if (value === undefined) {
            return undefined;
        }
        // The base field assumes the types are the same.
        const serializedValue = value;
        return serializedValue;
    }
    return {
        name,
        validate,
        fromApi,
        fromDb,
        toDb,
        toApi,
        getDefault,
        isRequired,
    };
}
exports.baseFieldFactory = baseFieldFactory;
//# sourceMappingURL=base.js.map